import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { queryTypes, servicesUserTypes } from 'src/types';
import { urlsConfig } from 'src/configs';
import { urlHelper } from '../helpers';
import { UpdatePasswordFormType } from '../components/Forms/PasswordChangeForm/passwordChange.config';
import { PreferredLanguage } from 'src/types/services/user-service.type';

export const lookupUsers = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: servicesUserTypes.UsersLookupDataType): AxiosPromise<servicesUserTypes.UsersLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.user.lookupUser), {
    blockSpinner,
  });
};

export const lookupUsersTable = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: servicesUserTypes.UsersLookupDataType): AxiosPromise<servicesUserTypes.UsersTableLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.user.lookupUser), {
    blockSpinner,
  });
};

export const lookupUsersNameTable = ({
  blockSpinner,
  load,
}: servicesUserTypes.UsersLookupDataType): AxiosPromise<servicesUserTypes.UserNamesTableResultType[]> => {
  const query: queryTypes.LookupQueryParametersType = {};

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.user.getUserNames), {
    blockSpinner,
  });
};

export const lookupAllUsersNameTable = ({
  blockSpinner,
  load,
}: servicesUserTypes.UsersLookupDataType): AxiosPromise<servicesUserTypes.UserNamesTableResultType[]> => {
  const query: queryTypes.LookupQueryParametersType = {};

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.user.getAllUserNames), {
    blockSpinner,
  });
};

export const createUser = (
  registerInformation: servicesUserTypes.RegisterCreateDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<servicesUserTypes.RegisterResultType> => {
  return axios.post(urlsConfig.user.createUser, registerInformation, options);
};

export const login = (
  loginInformation: servicesUserTypes.LoginDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<servicesUserTypes.LoginResultType> => {
  return axios.post(urlsConfig.user.login, loginInformation, options);
};

export const getMe = (): AxiosPromise<servicesUserTypes.GetInformationResultType> => {
  return axios.get(urlsConfig.user.getMe);
};

export const UpdateMePassword = (form: UpdatePasswordFormType): AxiosPromise<servicesUserTypes.UserEditResultType> => {
  return axios.patch(urlsConfig.user.updateMePassword, form, { blockErrorHandler: true });
};

export const getUsers = (): AxiosPromise<servicesUserTypes.Users> => {
  return axios.get(urlsConfig.user.users);
};

export const updateUsers = (
  form: Partial<servicesUserTypes.UserEditDataType>,
): AxiosPromise<servicesUserTypes.UserEditResultType> => {
  return axios.patch(urlsConfig.user.editUser, form, { blockErrorHandler: true });
};

export const updateMeProfile = (
  form: Partial<servicesUserTypes.UserEditDataType>,
): AxiosPromise<servicesUserTypes.UserEditResultType> => {
  return axios.patch(urlsConfig.user.updateMeProfile, form, { blockErrorHandler: true });
};

export const updateMeLanguage = (
  preferredLanguage: PreferredLanguage,
): AxiosPromise<servicesUserTypes.UserEditResultType> => {
  return axios.patch(
    urlsConfig.user.updateMeLanguage,
    {
      preferredLanguage,
    },
    { blockErrorHandler: true },
  );
};

export const deleteUsers = ({
  id,
}: servicesUserTypes.UserDeleteDataType): AxiosPromise<servicesUserTypes.UserDeleteResultType> => {
  return axios.delete(`${urlsConfig.user.deleteUser}/${id}`, { blockErrorHandler: true });
};
